<template>
  <div>
    <div class="section">
      <button class="button">
        <router-link :to="{ name: 'edit-category-create' }">Add Category</router-link>
      </button>
    </div>
    <div class="all-catefories">
      <CategoryListItem v-for="category in categories" :key="category.id" :category="category" />
    </div>
  </div>
</template>

<script>
import { firestore } from "@/firebase";
import CategoryListItem from "@/components/CategoryListItem";

const CATEGORIES_COLLECTION = "Categories";

export default {
  data() {
    return {
      categories: [],
      parentCategories: []
    };
  },
  components: {
    CategoryListItem
  },
  mounted() {
    firestore.collection(CATEGORIES_COLLECTION).onSnapshot(snapshot => {
      let categories = snapshot.docs.map(d => {
        var data = d.data();
        data.id = d.id;
        return data;
      });
      this.categories = categories;
    });
  }
};
</script>